/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const pushCapabilitySchema = z.object({
  asyncBulkPush: z.boolean(),
  customFieldTypes: z
    .array(
      z.enum([
        'SELECT',
        'MULTI_SELECT',
        'DATE',
        'DATETIME',
        'TEXT',
        'MULTILINE_TEXT',
        'NUMERIC',
        'CHECKBOX',
        'MULTI_CHECKBOX',
        'USER',
        'MULTI_USER',
        'TEAM',
        'VERSION',
        'COMPONENT',
        'LABELS',
      ]),
    )
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  hierarchyWrite: z.boolean(),
  itemCreate: z.boolean(),
  standardFields: z
    .array(
      z.enum([
        'SUMMARY',
        'STATUS',
        'ASSIGNEE',
        'TEAM',
        'ESTIMATE',
        'EXPECTED_START_DATE',
        'EXPECTED_FINISH_DATE',
        'PLANNED_START_DATE',
        'PLANNED_FINISH_DATE',
        'PARENT',
      ]),
    )
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
});
